<template>
	<ImageDisplayModal v-if="this.displayImgUrl !== null" :img-url="this.displayImgUrl" @closeImage="onCloseImage"></ImageDisplayModal>
	<div class="general-modal-bg">
		<div class='general-modal-container'>
			<div class='general-modal-header-container'>
				<div>工单详情</div>
				<img class="general-modal-header-close-btn" src="../images/close_white.svg" alt="close"
				     @click="this.onClose">
			</div>
			<div class="topic-detail-container">
				<div class='topic-title'>
					<span>标题：{{ this.ticketItem?.userDescription }}</span>
					<img v-if="this.ticketItem?.userDescription" src="../images/copy_light.svg" alt="复制"
					     class="copy-text-btn" title="复制标题"
					     @click="onCopyText(this.ticketItem?.userDescription, '标题')">
				</div>
				<div class='topic-type'>工单类型
					<img v-if="this.viewTicketType === false" src="../images/view_close.svg" alt="view"
					     @click="onViewTicketType(true)" style="cursor: pointer;margin-left: 0.2em;">
					<img v-if="this.viewTicketType === true" src="../images/view_open.svg" alt="view"
					     @click="onViewTicketType(false)" style="cursor: pointer;margin-left: 0.2em;">
				</div>
				<div class="topic-type-container" v-if="this.viewTicketType===true">
					<div v-for="(item) in this.ticketItem?.topicType" :key="item.key" class='topic-type'>
						<span class="topic-type-label">{{ item.label }}</span>
					</div>
				</div>

				<div class='topic-email topic-email-row'>
					<span>邮箱：{{ this.ticketItem?.email }}</span>
					<img v-if="this.ticketItem?.email" src="../images/copy_light.svg" alt="复制"
					     class="copy-text-btn" title="复制邮箱"
					     @click="onCopyText(this.ticketItem?.email, '邮箱')">
				</div>
				<div class='topic-email'>创建时间：{{ this.ticketItem?.createdTimeString }}</div>
				<div class='topic-email'>更新时间：{{ this.ticketItem?.updatedTimeString }}</div>
				<div class='topic-email'>总工单数：{{ this.topicCount === null ? '加载中...' : this.topicCount }}</div>
				<div class='user-detail'>用户详情
					<img v-if="this.viewUserDetail === false" src="../images/view_close.svg" alt="view"
					     @click="onViewDetail(true)" style="cursor: pointer;margin-left: 0.2em;">
					<img v-if="this.viewUserDetail === true" src="../images/view_open.svg" alt="view"
					     @click="onViewDetail(false)" style="cursor: pointer;margin-left: 0.2em;">
				</div>
				<div class='user-detail-container' v-if="this.viewUserDetail === true">
					<div>注册时间：{{ this.formatTimeString(this.userDetail?.registerTime) }}</div>
					<div>上次登录：{{ this.formatTimeString(this.userDetail?.lastLoginTime) }}</div>
					<div>会员到期：{{ this.formatTimeString(this.userDetail?.planExpireTime) }}</div>
					<div>支付数量：{{ this.userDetail?.paymentCount }}</div>
					<div>推荐数量：{{ this.userDetail?.referCount }}</div>
					<div>推荐人：{{ this.userDetail?.referByEmail || '无' }}</div>
					<div>推荐码：{{ this.userDetail?.referByCode || '无' }}</div>
				</div>

				<div class='ticket-img' v-if="this.ticketItem.images?.length > 0">图片</div>
				<div class="ticket-img-container" v-if="this.ticketItem.images?.length > 0">
					<div v-for="(item) in this.ticketItem?.images" class="ticket-img-wrapper" :key="item" @click="onImageClicked(item)">
						<img :src=item alt="image" style="max-width: 100%; max-height: 100%;"></div>
				</div>
				<!-- 建单时上传的录屏：和图片分开存（videos），直接内嵌播放器 -->
				<div class='ticket-img' v-if="this.ticketItem.videos?.length > 0">录屏</div>
				<div class="ticket-video-container" v-if="this.ticketItem.videos?.length > 0">
					<video v-for="(item) in this.ticketItem?.videos" :key="item" :src="item" class="ticket-video"
					       controls preload="metadata"></video>
				</div>
				<div class='device-info-label'>设备信息
					<img v-if="this.viewDeviceInfo === false" src="../images/view_close.svg" alt="view"
					     @click="onViewDeviceInfo(true)" style="cursor: pointer;margin-left: 0.2em;">
					<img v-if="this.viewDeviceInfo === true" src="../images/view_open.svg" alt="view"
					     @click="onViewDeviceInfo(false)" style="cursor: pointer;margin-left: 0.2em;">
				</div>
				<div class="device-info-container" v-if="this.viewDeviceInfo === true">
					<div class="flex-table">
						<div class="table-header">
							<div class="table-cell">系统</div>
							<div class="table-cell">版本</div>
							<div class="table-cell">设备ID</div>
							<div class="table-cell">是否在线</div>
							<div class="table-cell">更新时间</div>
							<div class="table-cell">创建时间</div>
							<div class="table-cell">显示额外日志</div>
						</div>
						<template v-for="item in this.deviceInfo" :key="item.deviceId">
							<!--							<div class="device-info-row">{{item.os + ' v' + item.version}}</div>-->
							<!-- 判 deviceId 而不是 os：库里约 27% 的设备记录没有 os 字段，
							     按 os 过滤会让这些设备在面板上完全不可见 -->
							<div class="table-row" v-if="item.deviceId">
								<div class="table-cell">{{ item.os || '-' }}</div>
								<div class="table-cell">{{ item.version || '-' }}</div>
								<div class="table-cell device-id-cell" :title="item.deviceId">
									<span class="device-id-text">{{ maskDeviceId(item.deviceId) }}</span>
									<img v-if="item.deviceId" src="../images/copy_light.svg" alt="复制"
									     class="copy-device-id-btn" title="复制设备ID"
									     @click="onCopyDeviceId(item.deviceId)">
								</div>
								<div class="table-cell">
									<span :class="['online-dot', item.online ? 'is-online' : 'is-offline']"></span>
									<span>{{ item.online ? '在线' : '离线' }}</span>
								</div>
								<div class="table-cell">{{ item.updateTimeString }}</div>
								<div class="table-cell">{{ item.createTimeString }}</div>
								<div class="table-cell">
									<a-switch size="small"
									          :checked="item.showExtraLog === true"
									          :loading="this.extraLogUpdating === item.deviceId"
									          :disabled="!item.deviceId"
									          @change="onToggleExtraLog(item, $event)"/>
								</div>
							</div>
						</template>
					</div>

				</div>
				<div class='topic-conversation'>对话：<br></div>
				<template v-for="(item, index) in this.conversationList" :key="item.feedbackChatRecordId || index">
					<div class="cs-chat-content-wrapper">
						<div
							:class="[item.isClientChat === true ? 'cs-topic-detail-client-chat' : 'cs-topic-detail-cs-chat']"
							style="width: 100%;text-align: start;">
							<div class="chat-box-header">
								<div class="chat-box-talker-container">
									{{ (item.isClientChat === true ? '用户：\n' : '我：\n') }}
								</div>
								<div class="chat-box-action-container" v-if="item.isClientChat !== true">
									<!-- 只改文字：纯附件的留言没有文字可改，不给编辑按钮 -->
									<img v-if="item.chatContent && this.editingChatId !== item.feedbackChatRecordId"
									     src="../images/edit_light.svg" alt="edit chat" title="编辑这条回复"
									     class="chat-action-btn" @click="onEditChat(item)">
									<!-- 只有客服自己的留言能删；硬删没有撤销，所以要二次确认 -->
									<a-popconfirm title="确认删除这条回复？用户端将不再显示，不可恢复"
									              ok-text="确认删除" cancel-text="取消" ok-type="danger"
									              @confirm="onDeleteChat(item)">
										<img src="../images/delete_chat.svg" alt="delete chat" title="删除这条回复"
										     class="chat-action-btn"
										     :style="{opacity: this.deletingChatId === item.feedbackChatRecordId ? 0.4 : 1}">
									</a-popconfirm>
								</div>
							</div>
							<template v-if="this.editingChatId === item.feedbackChatRecordId">
								<textarea class="agent-reply-editor chat-edit-editor" rows="4" v-model="this.editingChatContent"/>
								<div class="agent-reply-btn-container">
									<div class="agent-reply-btn is-approve" @click="onSaveEditChat(item)">保存</div>
									<div class="agent-reply-btn is-edit" @click="onCancelEditChat">取消</div>
								</div>
							</template>
							<!-- 插值紧贴标签写：上面那条 white-space: pre-wrap 会把模板里的换行和缩进
							     也当成内容渲染出来，气泡上下就会多出空行、每行前面还带一截缩进 -->
							<div v-else
								:class="[item.isClientChat === true ? 'chat-box-client-msg-container' : 'chat-box-my-msg-container']"
							>{{ item.chatContent }}</div>
							<div class="chat-attachment-container" v-if="item.attachments?.length > 0">
								<template v-for="(att) in item.attachments" :key="att.url">
									<div v-if="att.type === 'image'" class="ticket-img-wrapper" @click="onImageClicked(att.url)">
										<img :src="att.url" alt="attachment" style="max-width: 100%; max-height: 100%;">
									</div>
									<video v-else :src="att.url" class="ticket-video" controls preload="metadata"></video>
								</template>
							</div>

							<div style="width: 100%;text-align: right;">{{ item.createdTimeString }}</div>
						</div>
					</div>
				</template>

				<!-- AI 生成的待审批回复。放在对话最末尾，位置和它将来发出去之后一样，
				     这样管理员看到的顺序就是用户将来看到的顺序 -->
				<div class="agent-reply-card" v-if="this.pendingReply">
					<div class="agent-reply-header">
						<span class="agent-reply-tag">待审批的 AI 回复</span>
						<span class="agent-reply-meta" v-if="this.pendingReply.createdTimeString">
							{{ this.pendingReply.createdTimeString }}
						</span>
					</div>

					<textarea class="agent-reply-editor" rows="5" v-if="this.isEditingReply"
					          v-model="this.editingContent"/>
					<div class="agent-reply-content" v-else>{{ this.pendingReply.replyContent }}</div>

					<div class="agent-reply-btn-container">
						<template v-if="this.isEditingReply">
							<div class="agent-reply-btn is-approve" @click="onApproveAgentReply(true)">保存并发送</div>
							<div class="agent-reply-btn is-edit" @click="onCancelEditAgentReply">取消编辑</div>
						</template>
						<template v-else>
							<div class="agent-reply-btn is-approve" @click="onApproveAgentReply(false)">同意回复</div>
							<div class="agent-reply-btn is-reject" @click="onRejectAgentReply">驳回</div>
							<div class="agent-reply-btn is-edit" @click="onEditAgentReply">编辑</div>
						</template>
					</div>
				</div>
			</div>

			<div class="editor-container">
				<textarea class='cs-input' type="text" placeholder='请在此输入信息' rows="3" v-model="this.toSendMsg"/>
				<div class="editor-btn-container">
					<a-button type="primary" size="middle" @click="sendMsgReply"
					          style="color: #191123FF;background-color: #FF8900;margin-left: 0.2em;margin-bottom: 0.2em;">
						发送
					</a-button>
					<!-- 发截图 / 录屏：选中即作为一条单独的客服回复发出 -->
					<a-button type="primary" size="middle" @click="onPickAttachment" :loading="this.attachmentUploading"
					          title="发送截图或录屏（png/jpg 5MB，mp4 50MB）"
					          style="color: #191123FF;background-color: #FF8900;margin-left: 0.2em;">
						<img v-if="!this.attachmentUploading" src="../images/attachment.svg" alt="attachment">
					</a-button>
					<input type="file" ref="attachmentInput" style="display: none"
					       accept="image/png,image/jpeg,video/mp4,video/webm,video/quicktime,video/3gpp,.png,.jpg,.jpeg,.mp4,.webm,.mov,.3gp"
					       @change="onAttachmentChange">
				</div>

			</div>
		</div>
	</div>
</template>
<script>
import {copyToClipboard, hideLoading, postRequestAsync, showLoading, uploadFile} from "@/utils/methods";
import adminWs from "@/utils/adminWs";
import moment from "moment-timezone";
import ImageDisplayModal from "../components/ImageDisplayModal.vue";

export default {
	name: "TopicDetailModal",
	components: {ImageDisplayModal},
	data() {
		return {
			conversationList: [],
			// AI 生成、等管理员点头的那条回复。没有就是 null，卡片不显示
			pendingReply: null,
			isEditingReply: false,
			editingContent: '',
			isApproving: false,
			viewUserDetail: false,
			userDetail: null,
			toSendMsg: '',
			// 正在上传客服附件（截图/录屏），期间附件按钮转圈、禁止重复选文件
			attachmentUploading: false,
			// 正在删除的留言 id，防连点
			deletingChatId: null,
			// 正在编辑的留言 id 和编辑框内容；同一时间只编辑一条
			editingChatId: null,
			editingChatContent: '',
			isSavingChat: false,
			viewTicketType: false,
			viewDeviceInfo: false,
			deviceInfo: [],
			// 正在切换额外日志开关的 deviceId，用于给对应那一行的 switch 上 loading
			extraLogUpdating: null,
			// adminWs 状态订阅的注销函数，组件卸载时调用
			unsubscribeDeviceStatus: null,
			displayImgUrl: null,
			// 该账号提交过的工单总数，null 表示还没拉到
			topicCount: null
		}
	},
	props: {
		ticketItem: {
			type: Object,
			required: true,
			toSendMsg: ''
		}
	},
	async mounted() {
		await this.getChat()
		// 不 await：工单数只是个附带信息，没必要拖住详情页的其它内容
		this.getTopicCount()
		// 只注册回调，不管连接——连接是 App 级的，由 adminWs 自己维持
		this.unsubscribeDeviceStatus = adminWs.onDeviceStatus((deviceId, online) => {
			const target = this.deviceInfo.find(d => d.deviceId === deviceId)
			if (target) {
				target.online = online
			}
		})
	},
	beforeUnmount() {
		// 注销回调并取消订阅，但**不断开连接**：连接是全局共享的
		if (this.unsubscribeDeviceStatus) {
			this.unsubscribeDeviceStatus()
			this.unsubscribeDeviceStatus = null
		}
		adminWs.unwatchAll()
	},
	methods: {
		onCloseImage() {
			this.displayImgUrl = null
		},
		onClose() {
			this.$emit('close');
		},
		async sendMsgReply() {
			if (!this.toSendMsg) {
				this.$message.error('对话信息不能为空')
				return
			}
			showLoading()
			const result = await postRequestAsync('admin/cs/sendTopicReply', {
				topicId: this.ticketItem?.feedbackTopicId,
				msg: this.toSendMsg
			})
			hideLoading()

			if (result.code === 200) {
				this.$message.success('发送成功');
				this.conversationList = result?.msg
				this.toSendMsg = ''
				this.$emit('ticketUpdated')
				// 人工已经回过了，工单转成"已回复"，那张 AI 审批卡片就不该再留着
				await this.getPendingAgentReply()
			}
		},
		/**
		 * 删除一条客服留言。成功后直接从列表里摘掉，不重拉整段对话。
		 */
		async onDeleteChat(item) {
			if (!item?.feedbackChatRecordId) {
				this.$message.error('这条留言缺少 id，请关闭弹窗重新打开后再试')
				return
			}
			if (this.deletingChatId) {
				return
			}
			this.deletingChatId = item.feedbackChatRecordId
			showLoading()
			try {
				const result = await postRequestAsync('admin/cs/deleteTopicChat', {
					topicId: this.ticketItem?.feedbackTopicId,
					chatRecordId: item.feedbackChatRecordId
				})
				if (result?.code === 200 || result?.code === 203) {
					// 203 = 已经不存在了，列表里也不用留
					this.conversationList = this.conversationList.filter(chat => chat.feedbackChatRecordId !== item.feedbackChatRecordId)
					this.$message.success(result.code === 200 ? '已删除' : '这条留言已经不存在了')
				} else if (result?.code === 204) {
					this.$message.error('用户的留言不能删除')
				} else {
					this.$message.error(`删除失败${result?.code ? `（${result.code}）` : ''}`)
				}
			} finally {
				hideLoading()
				this.deletingChatId = null
			}
		},
		onEditChat(item) {
			if (!item?.feedbackChatRecordId) {
				this.$message.error('这条留言缺少 id，请关闭弹窗重新打开后再试')
				return
			}
			this.editingChatId = item.feedbackChatRecordId
			this.editingChatContent = item.chatContent || ''
		},
		onCancelEditChat() {
			this.editingChatId = null
			this.editingChatContent = ''
		},
		/**
		 * 保存改过的客服留言。只改文字，发送时间和工单状态不变；
		 * 成功后就地替换这一条，不重拉整段对话。
		 */
		async onSaveEditChat(item) {
			if (this.isSavingChat) {
				return
			}
			const msg = this.editingChatContent || ''
			if (!msg.trim()) {
				this.$message.error('回复内容不能为空')
				return
			}
			if (msg === item.chatContent) {
				this.onCancelEditChat()
				return
			}
			this.isSavingChat = true
			showLoading()
			try {
				const result = await postRequestAsync('admin/cs/editTopicChat', {
					topicId: this.ticketItem?.feedbackTopicId,
					chatRecordId: item.feedbackChatRecordId,
					msg
				})
				if (result?.code === 200) {
					item.chatContent = result?.msg?.chatContent ?? msg
					this.onCancelEditChat()
					this.$message.success('已修改')
				} else if (result?.code === 203) {
					this.$message.error('这条留言已经不存在了')
				} else if (result?.code === 204) {
					this.$message.error('用户的留言不能修改')
				} else {
					this.$message.error(`修改失败${result?.code ? `（${result.code}）` : ''}`)
				}
			} finally {
				this.isSavingChat = false
				hideLoading()
			}
		},
		onPickAttachment() {
			if (this.attachmentUploading) {
				return
			}
			this.$refs.attachmentInput?.click()
		},
		/**
		 * 客服发截图/录屏。类型和大小上限与服务端 utils/methods.js 的 ATTACHMENT_TYPES / ATTACHMENT_SIZE_LIMIT 一致，
		 * 这里先拦一道是为了马上给出原因，而不是等 50MB 传完再被服务端拒绝
		 */
		async onAttachmentChange(event) {
			const file = event.target.files?.[0]
			// 清掉选择，否则再选同一个文件不会触发 change
			event.target.value = ''
			if (!file) {
				return
			}
			const ext = (file.name.split('.').pop() || '').toLowerCase()
			const isImage = ['png', 'jpg', 'jpeg'].includes(ext)
			const isVideo = ['mp4', 'webm', 'mov', '3gp'].includes(ext)
			if (!isImage && !isVideo) {
				this.$message.error('只支持 png / jpg 截图和 mp4 录屏')
				return
			}
			if (isImage && file.size > 5 * 1024 * 1024) {
				this.$message.error('截图不能超过 5MB')
				return
			}
			if (isVideo && file.size > 50 * 1024 * 1024) {
				this.$message.error('录屏不能超过 50MB')
				return
			}

			const formData = new FormData()
			formData.append('topicId', this.ticketItem?.feedbackTopicId)
			// 文件字段放最后：服务端 multer 只能拿到它之前解析完的文本字段
			formData.append('file', file)

			this.attachmentUploading = true
			await uploadFile('admin/cs/uploadTopicAttachment', formData, () => {
			}, async (result) => {
				this.attachmentUploading = false
				if (result?.code === 200) {
					this.$message.success('发送成功')
					this.conversationList = result.msg
					this.$emit('ticketUpdated')
					await this.getPendingAgentReply()
					return
				}
				const reason = {
					303: isVideo ? '录屏不能超过 50MB' : '截图不能超过 5MB',
					305: '只支持 png / jpg 截图和 mp4 录屏',
					302: '文件存储失败，请重试',
					203: '工单不存在'
				}[result?.code]
				this.$message.error(reason || `发送失败（${result?.code ?? '网络错误'}）`)
			}, () => {
				this.attachmentUploading = false
				this.$message.error('发送失败，请检查网络后重试')
			})
		},
		async onViewDetail(shouldView) {
			this.viewUserDetail = shouldView
			if (shouldView === true && !this.userDetail) {
				await this.getUserDetail()
			}
		},
		onViewTicketType(view) {
			this.viewTicketType = view
		},
		formatTimeString(timestamp) {
			if (!timestamp) {
				return '无'
			}
			return moment(parseInt(timestamp) * 1000).tz('Asia/Shanghai').format('YYYY-MM-DD HH:mm:ss');
		},
		/**
		 * 该账号一共提交过多少工单。失败就保持 0，不弹错误——
		 * 为一个附带的计数打断客服看工单不值当。
		 */
		async getTopicCount() {
			if (!this.ticketItem?.email) {
				this.topicCount = 0
				return
			}
			const result = await postRequestAsync('admin/cs/getUserTopicCount', {
				email: this.ticketItem?.email
			})
			this.topicCount = result?.code === 200 ? (result?.msg?.count || 0) : 0
		},
		async getUserDetail() {
			if (!this.ticketItem?.email) {
				return
			}
			showLoading()
			try {
				const result = await postRequestAsync('admin/cs/getVpnUserDetail', {
					email: this.ticketItem?.email
				})
				if (result?.code === 200) {
					this.userDetail = result?.msg
				}
			} finally {
				hideLoading()
			}
		},
		async getChat() {
			if (!this.ticketItem?.feedbackTopicId) {
				return
			}
			showLoading()
			try {
				const result = await postRequestAsync('admin/cs/getVpnTopicChat', {
					ticketId: this.ticketItem?.feedbackTopicId
				})
				if (result?.code === 200) {
					this.conversationList = result?.msg
				}
			} finally {
				hideLoading()
			}
			await this.getPendingAgentReply()
		},
		/**
		 * 拉这条工单上待审批的 AI 回复。
		 *
		 * 不看 topicState 而是直接问有没有待审批记录：回复一旦发出去，记录就被标成
		 * 已审批、这里自然查不到了，所以"有记录"本身就等价于"还等着回复"，
		 * 而且不会受状态字段没同步的影响。
		 *
		 * 失败不弹错：这只是工单详情上的一块附加内容，为它打断看工单不值当。
		 */
		async getPendingAgentReply() {
			if (!this.ticketItem?.feedbackTopicId) {
				return
			}
			const result = await postRequestAsync('admin/cs/getPendingAgentReply', {
				messageType: 'topic',
				feedbackTopicId: this.ticketItem?.feedbackTopicId
			})
			this.pendingReply = result?.code === 200 ? (result?.msg?.pendingReply || null) : null
			this.isEditingReply = false
			this.editingContent = ''
		},
		onEditAgentReply() {
			this.editingContent = this.pendingReply?.replyContent || ''
			this.isEditingReply = true
		},
		onCancelEditAgentReply() {
			this.isEditingReply = false
			this.editingContent = ''
		},
		/**
		 * 同意并发送。
		 *
		 * @param withEdit 是否把编辑框里改过的内容一起发出去。
		 *        改过的内容后端会存回记录，发出去的和存档的始终是同一份。
		 */
		async onApproveAgentReply(withEdit) {
			if (!this.pendingReply || this.isApproving) {
				return
			}
			const replyContent = withEdit ? (this.editingContent || '').trim() : ''
			if (withEdit && !replyContent) {
				this.$message.error('回复内容不能为空')
				return
			}

			this.isApproving = true
			showLoading()
			try {
				const result = await postRequestAsync('admin/cs/approveAgentReply', {
					agentReplyRecordId: this.pendingReply.agentReplyRecordId,
					isApprove: true,
					replyContent: withEdit ? replyContent : undefined
				})
				if (result?.code === 200) {
					this.pendingReply = null
					this.isEditingReply = false
					this.$message.success('已发送给用户')
					// 发出去的回复现在是一条正式的对话记录，重新拉一遍列表
					await this.getChat()
					// 工单状态变成"已回复"，外面的列表也要跟着更新。
					// 这个弹窗用的事件名是 ticketUpdated（发送回复那里也是这个）
					this.$emit('ticketUpdated')
				} else if (result?.code === 304) {
					this.$message.warning('这条回复已经被处理过了')
					await this.getPendingAgentReply()
				} else {
					this.$message.error(`操作失败${result?.code ? `（${result.code}）` : ''}`)
				}
			} finally {
				this.isApproving = false
				hideLoading()
			}
		},
		/**
		 * 驳回：只把记录标成已处理，不发给用户。
		 */
		async onRejectAgentReply() {
			if (!this.pendingReply || this.isApproving) {
				return
			}
			this.isApproving = true
			showLoading()
			try {
				const result = await postRequestAsync('admin/cs/approveAgentReply', {
					agentReplyRecordId: this.pendingReply.agentReplyRecordId,
					isApprove: false
				})
				if (result?.code === 200 || result?.code === 304) {
					this.pendingReply = null
					this.isEditingReply = false
					this.$message.success('已驳回，未发送给用户')
				} else {
					this.$message.error(`操作失败${result?.code ? `（${result.code}）` : ''}`)
				}
			} finally {
				this.isApproving = false
				hideLoading()
			}
		},
		async getDeviceInfo() {
			showLoading()
			const result = await postRequestAsync('admin/cs/getDeviceInfo', {
				ticketId: this.ticketItem?.feedbackTopicId
			})
			hideLoading()

			if (result.code === 200) {
				this.deviceInfo = result?.msg
			}
		},
		async onViewDeviceInfo(view) {
			if (view === true && this.deviceInfo.length === 0) {
				await this.getDeviceInfo()
			}
			this.viewDeviceInfo = view
			// 展开时告诉服务端要盯哪些设备（服务端会立刻回一份状态快照），收起时取消订阅。
			// 连接本身由 adminWs 全局维持，这里不建立也不断开
			if (view === true) {
				adminWs.watchDevices(this.deviceInfo.map(d => d.deviceId).filter(Boolean))
			} else {
				adminWs.unwatchAll()
			}
		},
		/**
		 * 设备ID 打码显示：前四位 + **** + 后四位。
		 * 太短（不足 8 位）就原样显示——再打码就没剩几位可看了，也没有隐藏的意义。
		 * 注意复制按钮和 title 用的都是完整 ID，这里只影响表格上的呈现。
		 */
		maskDeviceId(deviceId) {
			if (!deviceId) {
				return '-'
			}
			if (deviceId.length <= 8) {
				return deviceId
			}
			return `${deviceId.slice(0, 4)}****${deviceId.slice(-4)}`
		},
		/**
		 * 复制任意一段文本。label 只用来拼提示语（"标题已复制"），
		 * 复制失败一律提示手动选中——浏览器在非安全上下文里会直接拒绝写剪贴板。
		 */
		async onCopyText(text, label) {
			if (!text) {
				return
			}
			const ok = await copyToClipboard(text)
			if (ok) {
				this.$message.success(`${label}已复制`)
			} else {
				this.$message.error('复制失败，请手动选中复制')
			}
		},
		async onCopyDeviceId(deviceId) {
			if (!deviceId) {
				return
			}
			const ok = await copyToClipboard(deviceId)
			if (ok) {
				this.$message.success('设备ID已复制')
			} else {
				this.$message.error('复制失败，请手动选中复制')
			}
		},
		/**
		 * 切换该设备的额外日志（流畅度诊断）上报。
		 *
		 * 用 :checked + @change 而不是 v-model：接口失败时开关不会停在错误的位置上，
		 * 只有服务端确认成功才更新本地状态。
		 */
		async onToggleExtraLog(item, checked) {
			if (!item?.deviceId) {
				this.$message.error('该设备没有设备ID，无法开启')
				return
			}
			if (this.extraLogUpdating) {
				return
			}
			this.extraLogUpdating = item.deviceId
			try {
				const result = await postRequestAsync('admin/cs/updateExtraLogSwitch', {
					deviceId: item.deviceId,
					isOn: checked
				})
				if (result?.code === 200) {
					item.showExtraLog = checked
					// delivered 只表示是否已即时推给在线设备；为 false 时开关已存库，
					// 设备下次连上会自动拿到，不算失败
					if (checked) {
						this.$message.success(
							result?.msg?.delivered === true ? '已开启，指令已下发到设备' : '已开启，设备当前不在线，上线后生效'
						)
					} else {
						this.$message.success('已关闭额外日志上报')
					}
				} else {
					this.$message.error(`操作失败${result?.code ? `（${result.code}）` : ''}`)
				}
			} finally {
				this.extraLogUpdating = null
			}
		},
		onImageClicked(url) {
			this.displayImgUrl = url
		}
	}
}
</script>
<style scoped>

/* 待审批的 AI 回复。用虚线框和普通对话气泡区分开——
   它还没发出去，不能看着像已经在对话里的一条 */
.agent-reply-card {
	box-sizing: border-box;
	width: 100%;
	margin: 0.6em 0 1em 0;
	padding: 0.8em;
	border: 1px dashed #FF8900;
	border-radius: 0.4em;
	background-color: rgba(255, 137, 0, 0.06);
	text-align: left;
}

.agent-reply-header {
	display: flex;
	flex-direction: row;
	align-items: center;
	flex-wrap: wrap;
	gap: 0.5em;
	margin-bottom: 0.5em;
}

.agent-reply-tag {
	color: #191123;
	background-color: #FF8900;
	font-size: 0.9em;
	padding: 0.1em 0.5em;
	border-radius: 0.3em;
	white-space: nowrap;
}

.agent-reply-meta {
	color: rgba(230, 213, 184, 0.5);
	font-size: 0.85em;
}

/* 回复里的换行是有意义的，别被折叠掉 */
.agent-reply-content {
	color: #E6D5B8;
	white-space: pre-wrap;
	word-break: break-word;
	line-height: 1.5em;
}

.agent-reply-editor {
	box-sizing: border-box;
	width: 100%;
	color: #E6D5B8;
	background-color: rgba(0, 0, 0, 0.3);
	border: 1px solid rgba(230, 213, 184, 0.6);
	border-radius: 0.3em;
	/* App.vue 里有全局的 input/textarea 内边距重置，不加 !important 撑不开 */
	padding: 0.5em !important;
	line-height: 1.5em;
	outline: none;
	resize: vertical;
}

.agent-reply-editor:focus {
	border-color: #FF8900;
}

.agent-reply-btn-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	flex-wrap: wrap;
	justify-content: flex-end;
	gap: 0.5em;
	margin-top: 0.6em;
}

.agent-reply-btn {
	color: #191123;
	font-size: 0.9em;
	padding: 0.3em 0.9em;
	border: 1px solid transparent;
	border-radius: 0.3em;
	cursor: pointer;
	white-space: nowrap;
}

.agent-reply-btn.is-approve {
	background-color: #52c41a;
	border-color: #52c41a;
}

.agent-reply-btn.is-reject {
	background-color: #ff6b6b;
	border-color: #ff6b6b;
}

/* 编辑不改变任何数据，做成描边的次要按钮，和另外两个拉开轻重 */
.agent-reply-btn.is-edit {
	color: #FF8900;
	background-color: transparent;
	border-color: #FF8900;
}

.general-modal-container {
	position: relative;
	background-color: #1f1f35;
	overflow-y: hidden;
	display: flex;
	flex-direction: column;
	padding: 0.4em;
}

/* 手机上 App.vue 给的是 width:100vw，弹窗左右完全贴边。
   这里只收一个宽度上限，左右各留出间距——弹窗本身是 left:50% + translate(-50%)
   居中的，收窄后自然两边对称，不需要动 margin。
   用 max-width 而不是覆盖 width，就不必去跟那条 !important 争特异性。 */
@media (max-width: 900px) {
	.general-modal-container {
		max-width: calc(100vw - 1.6em);
	}
}

.topic-title {
	width: 100%;
	font-size: 1.2em;
	color: #E6D5B8;
	text-align: start;
	word-wrap: break-word;
	display: flex;
	flex-direction: row;
	/* 标题可能折成多行，图标顶对齐才不会掉到中间去 */
	align-items: flex-start;
}

.topic-type {
	width: fit-content;
	font-size: 1.2em;
	color: #E6D5B8;
	text-align: start;
	word-wrap: break-word;
	display: flex;
	flex-direction: row;
	align-items: center;
}

.topic-email {
	width: 100%;
	font-size: 1.2em;
	color: rgba(230, 213, 184, 0.8);
	text-align: start;
}

/* 只有邮箱那一行要放复制按钮，创建/更新时间共用 .topic-email 但不需要横向布局 */
.topic-email-row {
	display: flex;
	flex-direction: row;
	align-items: center;
	word-break: break-all;
}

.copy-text-btn {
	width: 0.9em;
	height: 0.9em;
	flex: 0 0 auto;
	cursor: pointer;
	margin-left: 0.4em;
	/* 和文字首行的中线对齐，不然顶对齐时图标会偏高 */
	margin-top: 0.25em;
	opacity: 0.7;
}

.topic-email-row .copy-text-btn {
	margin-top: 0;
}

.copy-text-btn:hover {
	opacity: 1;
}

.user-detail {
	width: 100%;
	font-size: 1.2em;
	color: #E6D5B8;
	text-align: start;
	display: flex;
	flex-direction: row;
}

.user-detail-container {
	display: flex;
	font-size: 1.2em;
	line-height: 1.2em;
	flex-direction: column;
	width: 100%;
	color: #E6D5B8;
	align-items: start;
	background-color: rgba(230, 213, 184, 0.2);
	padding: 0.2em;
	box-sizing: border-box;
	border-radius: 0.2em;
}

.topic-conversation {
	width: 100%;
	font-size: 1.2em;
	color: #E6D5B8;
	text-align: start;
}

.cs-topic-detail-client-chat {
	background-color: rgba(255, 137, 0, 0.2);
	color: #FF8900;
	padding: 0.4em;
	border-radius: 0.4em;
	margin: 0.4em 0;
	width: fit-content;
	box-sizing: border-box;
}

.cs-topic-detail-cs-chat {
	background-color: rgba(230, 213, 184, 0.2);
	color: #E6D5B8;
	padding: 0.4em;
	border-radius: 0.4em;
	margin: 0.4em 0;
	width: fit-content;
	box-sizing: border-box;
}

.editor-container {
	bottom: 0;
	left: 0;
	display: flex;
	flex-direction: row;
	justify-content: center;
	width: 100%;
	padding: 0.2em 0.2em 2em 0.2em;
	align-items: flex-start;
	background-color: #1f1f35;
}

textarea {

	background-color: transparent;
	border: 1px solid #FF8900;
	border-radius: 0.2em;
	flex: 1;
	color: #FF8900;
	font-size: 1.2em;
	min-height: calc(3 * 1.4em); /* 最少3行 */
	max-height: calc(10 * 1.4em); /* 最多10行 */
	line-height: 1.4em;
	overflow-y: auto;
	resize: vertical;
	padding: 5px;
	box-sizing: border-box;
}

textarea:focus {
	border: 1px solid #FF8900;
}

textarea:focus-visible {
	outline: #ffad50 auto 1px;
}

/* 其他浏览器 */
textarea::placeholder {
	color: #c76c00;
}

.editor-btn-container {
	display: flex;
	flex-direction: column;
}

.topic-detail-container {
	display: flex;
	flex-direction: column;
	overflow-y: auto;
	overflow-x: hidden;
	flex: 1;
	/* 同上：不置 0 的话，设备信息表的固有宽度会顺着 flex 链把弹窗顶宽 */
	min-width: 0;
}

.chat-box-header {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

/* 客服留言右上角的编辑 / 删除按钮，编辑在左 */
.chat-box-action-container {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.6em;
}

.chat-action-btn {
	width: 1.2em;
	height: 1.2em;
	cursor: pointer;
}

/* 气泡本身是 width: fit-content，编辑框要占满一行才好改长回复 */
.chat-edit-editor {
	margin-top: 0.3em;
	min-width: min(40em, 70vw);
}

.chat-box-client-msg-container {
	color: #FF8900;
	word-wrap: break-word;
	/* 消息里的换行和缩进是内容的一部分（AI 回复带列表、用户贴日志），
	   HTML 默认会把它们折叠成一个空格，整段挤成一坨 */
	white-space: pre-wrap;
}

.chat-box-my-msg-container {
	color: #E6D5B8;
	word-wrap: break-word;
	white-space: pre-wrap;
}

.topic-type-container {
	display: flex;
	flex-direction: column;
	border: 1px solid #E6D5B8;
	padding: 0.2em;
	border-radius: 0.2em;
}

.topic-type-label {
	word-break: keep-all;
	white-space: nowrap;
	color: rgba(230, 213, 184, 0.8);
	line-height: 1.2em;
}

.ticket-img {
	width: 100%;
	font-size: 1.2em;
	color: #E6D5B8;
	text-align: start;
	display: flex;
	flex-direction: row;
}

.device-info-label {
	width: 100%;
	font-size: 1.2em;
	color: #E6D5B8;
	text-align: start;
	display: flex;
	flex-direction: row;
}

.ticket-img-container {
	display: flex;
	flex-direction: row;
	cursor: pointer;
}

.ticket-img-wrapper {
	width: 5em;
	height: 5em;
	background-color: #000;
	padding: 0.2em;
	box-sizing: border-box;
}

.ticket-video-container {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	gap: 0.4em;
}

.ticket-video {
	max-width: 16em;
	max-height: 12em;
	background-color: #000;
}

.chat-attachment-container {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	gap: 0.4em;
	margin-top: 0.3em;
}

.chat-attachment-container .ticket-img-wrapper {
	cursor: pointer;
}

.device-info-container {
	display: flex;
	flex-direction: column;
	border: 1px solid rgba(230, 213, 184, 0.5);
	padding: 0.2em;
	border-radius: 0.2em;
	margin: 0.4em 0;
	box-sizing: border-box;
	/* 七列在窄面板里放不下，交给横向滚动，不要把列压扁 */
	overflow-x: auto;
	/* flex item 默认 min-width:auto，会被子元素的固有宽度顶开，
	   连带把整个弹窗撑出屏幕。置 0 才允许它比内容窄，overflow-x 也才真正生效 */
	min-width: 0;
	width: 100%;
	/* flex-shrink 默认是 1：对话内容一长，这个容器就会被兄弟元素挤扁成一条线，
	   表格看起来"没有数据"。这里禁止压缩，高度由表格自身决定 */
	flex-shrink: 0;
	/* Firefox 没有 2px 这一档，thin 是能给到的最细 */
	scrollbar-width: thin;
	scrollbar-color: rgba(230, 213, 184, 0.6) transparent;
}

/* 横向滚动条：细到 2px，避免占掉本来就不多的纵向空间 */
.device-info-container::-webkit-scrollbar {
	height: 2px;
}

.device-info-container::-webkit-scrollbar-track {
	background: transparent;
}

.device-info-container::-webkit-scrollbar-thumb {
	background-color: rgba(230, 213, 184, 0.6);
	border-radius: 1px;
}

.device-info-row {
	display: flex;
	flex-direction: row;
	color: #E6D5B8;
}

.flex-table {
	display: flex;
	flex-direction: column;
	/* 七列的下限宽度（70+64+130+76+165+165+100）。窄于此不再压缩，由外层横向滚动 */
	min-width: 770px;
	font-family: Arial, sans-serif;
}

.table-header, .table-row {
	display: flex;
	flex-direction: row;
	border-bottom: 1px solid #E6D5B8;
	width: 100%;
	min-width: 100%;
	box-sizing: border-box;
}

.table-header {
	background-color: rgba(230, 213, 184, 0.3);
	font-weight: bold;
}

.table-cell {
	padding: 0.3em 0.6em;
	text-align: left;
	/* 关键：添加这些属性确保内容不会撑开单元格 */
	box-sizing: border-box;
	min-width: 0; /* 防止flex项目超出容器 */
	word-wrap: break-word; /* 长文本自动换行 */
	color: #E6D5B8;
}

/* 列分割线画在左边，这样最后一列不会多出一条 */
.table-cell + .table-cell {
	border-left: 1px solid rgba(230, 213, 184, 0.3);
}

/* 列序：系统 | 版本 | 设备ID | 是否在线 | 更新时间 | 创建时间 | 显示额外日志
   固定基准宽度让表头和数据行严格对齐；中间几列允许在宽面板下按比例撑开 */
.table-cell:nth-child(1) {
	flex: 0 0 70px; /* 系统 */
	white-space: nowrap;
}

.table-cell:nth-child(2) {
	flex: 0 0 64px; /* 版本 */
	white-space: nowrap;
}

.table-cell:nth-child(3) {
	flex: 1 1 130px; /* 设备ID（打码后固定 12 字符，不需要原来那么宽） */
}

.table-cell:nth-child(4) {
	flex: 0 0 76px; /* 是否在线 */
	white-space: nowrap;
}

.table-cell:nth-child(5),
.table-cell:nth-child(6) {
	flex: 1 1 165px; /* 更新时间 / 创建时间 */
}

/* 开关列：固定宽度，不跟着伸缩 */
.table-cell:nth-child(7) {
	flex: 0 0 100px;
	white-space: nowrap;
}

/* 在线状态指示点 */
.online-dot {
	display: inline-block;
	width: 0.5em;
	height: 0.5em;
	border-radius: 50%;
	margin-right: 0.4em;
	vertical-align: middle;
}

.online-dot.is-online {
	background-color: #52c41a;
}

.online-dot.is-offline {
	background-color: rgba(230, 213, 184, 0.35);
}

/* 设备ID 单元格：ID 文本 + 复制按钮并排 */
.device-id-cell {
	display: flex;
	align-items: center;
	gap: 0.4em;
}

/* 打码后长度固定，不再需要断行 */
.device-id-text {
	min-width: 0;
	white-space: nowrap;
}

.copy-device-id-btn {
	width: 1em;
	height: 1em;
	flex: 0 0 auto;
	cursor: pointer;
	/* copy_light.svg 是 copy.svg 的米色版（原图 fill 是主题橙 #ff8900，
	   直接 invert 会变成蓝色）。这里颜色已经和表格文字一致，只压一点不透明度 */
	opacity: 0.7;
}

.copy-device-id-btn:hover {
	opacity: 1;
}


</style>